import { Col, Image, Row, Typography } from "antd";
import React, { useCallback, useEffect, useRef, useState } from "react";
import AvatarUsername from "../commentItem/AvatarUsername";
import { CommentJson } from "features/comment/types/comment.type";
import StarRating from "../commentItem/StarRating";
import Timestamp from "../commentItem/Timestamp";
import Reaction from "./../commentItem/Reaction";
import CommentSwiper from "./../commentSwiper/CommentSwiper";
import FileModel from "common/models/FileModel";
import { FileJson } from "common/types/File";
import { IconChevronDown, IconChevronUp } from "@tabler/icons-react";
import Description from "../commentItem/Description";
import { ReviewDetailList } from "./ReviewDetail";
type Props = {
  data: ReviewDetailList;
  handleSetUrlImage: (url: string) => void;
  handleChangeSlide: (id: number, indexActive: number) => void;
  showLinkMore?: boolean;
  handleShowMore?: () => void;
};
const ReviewDetailRight = ({
  data,
  handleSetUrlImage,
  handleChangeSlide,
  showLinkMore = false,
  handleShowMore = () => {},
}: Props) => {
  const [isMore, setIsMore] = useState(false);

  const nodeReview = useRef<HTMLDivElement | null>(null);
  const nodeReviewViewMore = useRef<HTMLSpanElement | null>(null);
  const [indexActive, setIndexActive] = useState<number>(0);
  // function

  const toggleIsMore = useCallback(() => {
    setIsMore((prev) => !prev);
  }, []);

  const handleToggleViewMore = (type: "open" | "close") => {
    if (nodeReview.current && nodeReviewViewMore) {
      const text = nodeReview.current;
      const btnMore = nodeReviewViewMore.current;
      if (text && btnMore && type === "close") {
        text.scroll({
          left: 0,
          top: 0,
          behavior: "smooth",
        });
        text.style.overflow = "hidden";
      } else {
        text.style.overflow = "auto";
        text.scroll({
          left: 0,
          top: 100,
          behavior: "smooth",
        });
      }
    }
    setIsMore((prev) => (type === "close" ? false : true));
  };
  useEffect(() => {
    if (data?.activeImage !== undefined) {
      const i = data.activeImage;
      setIndexActive(i);
    }
  }, [data]);

  //
  return (
    <div id="review-detail-right" style={{ position: "relative" }}>
      {data ? (
        <Row gutter={0} style={{ width: "100%" }}>
          <Col span={24} style={{ marginBottom: 8 }}>
            <AvatarUsername username={data.name} isLoading={false} />
          </Col>
          <Col span={24} style={{ marginBottom: 10 }}>
            <StarRating
              titleRate={data.title}
              isLoading={false}
              stars={data.rate}
            />
          </Col>
          <Col span={24} style={{ marginBottom: 10 }}>
            <Timestamp
              style={{ fontSize: "12px", color: "#898889" }}
              isLoading={false}
              date_created={data.date_created}
            />
          </Col>

          <Description
            content={data.detail}
            parent_user={undefined}
            isLoading={false}
            type_list={"review"}
            className="description_review_wrapper"
            is_shadow_text={true}
          ></Description>
          <Col
            span={24}
            style={{
              marginBottom: 10,
              marginTop: data.detail.split("").length < 500 ? 10 : 0,
            }}
          >
            <Reaction
              id={data.id}
              isLiked={false}
              likeCount={data.like}
            ></Reaction>
          </Col>
          <Col span={24} style={{ marginTop: 10 }}>
            <Typography.Title
              style={{
                margin: "0 0 0 0",
                color: "#747474",
                fontSize: "14px",
              }}
              level={5}
            >
              Tất cả hình ảnh
            </Typography.Title>
            <CommentSwiper
              idSwiper="detail_right_image"
              initialSlide={0}
              styleWrapper={{ margin: "4px 0 0 0" }}
              dataSource={data.images}
              isloading={false}
              navigation={false}
              autoplay={false}
              responsive={{
                xxs: { slidesPerView: 2.8, spaceBetween: 8 },
                xs: { slidesPerView: 3, spaceBetween: 8 },
                sm: { slidesPerView: 3, spaceBetween: 8 },
                md: { slidesPerView: 3, spaceBetween: 8 },
                lg: { slidesPerView: 6, spaceBetween: 8 },
                xl: { slidesPerView: 6, spaceBetween: 8 },
              }}
              itemRender={(item: FileJson, index) => {
                return (
                  <div
                    className={`image_review_wrapper ${
                      indexActive === index ? "active_image" : ""
                    }`}
                  >
                    <Image
                      onTouchStart={() => console.log("hover")}
                      onClickCapture={() => {
                        handleChangeSlide(data.id, index);
                      }}
                      style={{
                        borderRadius: 4,
                        objectFit: "cover",
                        width: 60,
                        height: 60,
                        cursor: "pointer",
                      }}
                      width={60}
                      height={60}
                      preview={false}
                      src={FileModel.getThumbnailFromUrl(
                        item.file_path,
                        1080,
                        765,
                        "crop"
                      )}
                    ></Image>
                  </div>
                );
              }}
            ></CommentSwiper>
          </Col>
          {showLinkMore && (
            <Typography.Link
              color="
#004B8F"
              style={{ margin: "12px 0 0 0", fontSize: "12px" }}
              onClick={handleShowMore}
            >
              Xem hình ảnh khác
            </Typography.Link>
          )}
        </Row>
      ) : (
        ""
      )}
    </div>
  );
};

export default ReviewDetailRight;
